import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import PensionWorkflow from '../PensionWorkflow/PensionWorkflowContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';

const RetirementWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  isMobile,
  goToSummaryWhenReady,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Retirement');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      goToSummaryWhenReady={goToSummaryWhenReady}
      workflowId={workflowId}
      analyticsWorkflowStarted="retirement_workflow_started"
      outputFunction={outputFunction(clientId)}
      steps={[
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        AccountsWorkflow,
        PensionWorkflow,
      ]}
    />
  );
};

RetirementWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default RetirementWorkflowView;
